import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, FlexProps, useColorModeValue } from '@chakra-ui/react'
import { hasSomeValues } from '@Shared/utils/helpers';
import React from 'react'
import { IconType } from 'react-icons';
import { LinkItemProps } from './AppSidebar';
import SidebarNav from './SidebarNav';
import SidebarNavItem from './SidebarNavItem'

interface AccordionNavItemProps extends FlexProps {
  icon?: IconType;
  level: number;
  subMenu: LinkItemProps[] | undefined;
  name: string;
}

export const AccordionNav = ({icon, name, subMenu, level, ...rest}: AccordionNavItemProps) => {
  const hcolor = useColorModeValue('black', 'gray.100');
  const isOpen = hasSomeValues(subMenu, [window.location.pathname])
  const navItemColor = useColorModeValue('gray.600', 'gray.300');
  return (
      <Accordion allowToggle borderColor={'transparent'}>
        <AccordionItem>
          <h2>
            <AccordionButton title={name} _hover={{bg: 'gray.700'}} fontSize={"sm"} p={0} _expanded={{ bg: useColorModeValue('blue.100', 'blue.800'), color: hcolor }}>
              <SidebarNavItem level={level} color={isOpen ? hcolor : navItemColor} icon={icon} name={name} />
              <AccordionIcon right={5} position='absolute' color={useColorModeValue('gray.800', 'white')}/>
            </AccordionButton>
          </h2>
          {/* TODO : pl={8} */}
          <AccordionPanel p={0}>
            {subMenu ? <SidebarNav menuLinkData={subMenu} /> : ''}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
  )
}
